import type { components } from '@awj/api-client';

import type { MessageKey } from '~/i18n/messages.ts';

type Coupon = components['schemas']['CouponResponse'];

/** Where a code stands right now, worked out the same way the basket decides whether it applies. */
export function couponStanding(coupon: Coupon, now: number): { label: MessageKey; tone: string } {
  if (!coupon.isActive) {
    return { label: 'coupons.off', tone: 'archived' };
  }

  if (coupon.expiresAt && now >= Date.parse(coupon.expiresAt)) {
    return { label: 'coupons.expired', tone: 'cancelled' };
  }

  if (coupon.usageLimit != null && coupon.timesUsed >= coupon.usageLimit) {
    return { label: 'coupons.usedUp', tone: 'cancelled' };
  }

  if (coupon.startsAt && now < Date.parse(coupon.startsAt)) {
    return { label: 'coupons.scheduled', tone: 'draft' };
  }

  return { label: 'coupons.live', tone: 'active' };
}
